module.exports = __webpack_public_path__ + "img/topimg.5423cec8.png";